<template>
  <!-- !!! -->
  <!-- !!! -->
  <!-- !!! -->
  <!-- 若有改动，请仔细观察后端返回格式再来修改 -->
  <div>
    <div style="background-color: #ffffff;width: 100%;height: 70vh">
      <date-select @StatisticType="GetStatisticType" :Multiple="true"></date-select>
      <v-chart :options="option" :autoresize="true" v-show="CharShow" />
    </div>
  </div>
</template>

<script>
import { 
  otherStyle,
  GetFlowstatisticsMinute,
  GetFlowstatisticsYear,
  GetFlowstatisticsTime,
  GetFlowstatisticsDay 
} from './components/GetValue'
import ECharts from 'vue-echarts'
import { listTraffic } from '../../api/flowstatistics'
import 'echarts/lib/chart/line'
import 'echarts/lib/component/polar'
import DateSelect from "./components/DateSelect";
import { mapGetters } from 'vuex'
export default {
  name: 'Flowstatistics',
  data() {
    return {
    CharShow:false,
    option:{
    backgroundColor: "#fff",
    color: ["#37A2DA", "#32C5E9", "#67E0E3", "#9FE6B8"],
    tooltip: {
          trigger: "axis",
          axisPointer: otherStyle.axisPointer
        },
    legend: {
        x: 'center',
        data: ['3GWAN1', '3GWAN2', 'LAN', 'WAN']
    },
    legend: {
          data: [
            {
              name: "3GWAN1",
              icon: "circle",
              textStyle: {
                color: "#7d838b"
              }
            },
            {
              name: "3GWAN2",
              icon: "circle",
              textStyle: {
                color: "#7d838b"
              }
            },
            {
              name: "LAN",
              icon: "circle",
              textStyle: {
                color: "#7d838b"
              }
            },
            {
              name: "WAN",
              icon: "circle",
              textStyle: {
                color: "#7d838b"
              }
            }
          ],
          top: "10%",
          textStyle: {
            color: "#fff"
          }
        },
    xAxis: {
        type: 'category',
        boundaryGap: false,
        data: []
    },
    yAxis: {
        type: 'value',
        name: `${this.$t('lang.ReportManagement.Units')}(KB)`
    },
    grid:{
    x:'0px',
    y:'20%',
    x2:'40px',
    y2:'0px',
    containLabel: true
    },
    series: [{
            name: '3GWAN1',
            type: 'line',
            smooth: true,
            symbolSize: 1,
            symbol: 'circle',
            data: []
        }, {
            name: '3GWAN2',
            type: 'line',
            smooth: true,
            symbolSize: 1,
            symbol: 'circle',
            data: []
        }, {
            name: 'LAN',
            type: 'line',
            smooth: true,
            symbolSize: 1,
            symbol: 'circle',
            data: []
        }, {
            name: 'WAN',
            type: 'line',
            smooth: true,
            symbolSize: 1,
            symbol: 'circle',
            data: []
        }

    ]
}
    };
  },
  components: {
    DateSelect
  },
  mounted(){
    const Data=
    //进入页面获取当前用户默认分组下的设备流量统计
    listTraffic({year: new Date().getFullYear(),gid:this.defaultGroupId})
    .then((res)=>{
      if(res.data.data){
        const Data=GetFlowstatisticsYear(res.data.data,new Date().getFullYear())
        Object.keys(Data.data).length>0?this.CharShow=true:this.CharShow=false
        this.option.series[0].data=Data.data.net3gwan1
        this.option.series[1].data=Data.data.net3gwan2
        this.option.series[2].data=Data.data.netlan
        this.option.series[3].data=Data.data.netwan
        this.option.xAxis.data=Data.Time
      }
    })
  },
  methods: {
    //统计查询事件触发
    GetStatisticType(data,DayClass) {
      //获取统计的类型
        let Value=data.DateClassValue
        //删除统计类型
        delete data.DateClassValue
        //获取筛选后的数据与时间
        let Data;
        //请求数据
      listTraffic(data)
      .then((res)=>{
        switch (Value) {
        case 4:
            //使用自定义函数制作设备数据与数据时间
          Data=GetFlowstatisticsMinute(res.data.data,data.clock)
          Object.keys(Data.data).length>0?this.CharShow=true:this.CharShow=false
          this.option.series[0].data=Data.data.net3gwan1
          this.option.series[1].data=Data.data.net3gwan2
          this.option.series[2].data=Data.data.netlan
          this.option.series[3].data=Data.data.netwan
          this.option.xAxis.data=Data.Time
          break;
        case 3:
            //使用自定义函数制作设备数据与数据时间
          Data=GetFlowstatisticsTime(res.data.data,data.day)
          Object.keys(Data.data).length>0?this.CharShow=true:this.CharShow=false
          this.option.series[0].data=Data.data.net3gwan1
          this.option.series[1].data=Data.data.net3gwan2
          this.option.series[2].data=Data.data.netlan
          this.option.series[3].data=Data.data.netwan
          this.option.xAxis.data=Data.Time
          break;
        case 2:
            //使用自定义函数制作设备数据与数据时间
          Data=GetFlowstatisticsDay(res.data.data,data.month,DayClass)
          Object.keys(Data.data).length>0?this.CharShow=true:this.CharShow=false
          if(Object.keys(Data.data).length<1){
          this.$confirm(this.$t('lang.ReportManagement.datatype'), this.$t('lang.ReportManagement.setPrompt'), {
          confirmButtonText: this.$t('lang.ReportManagement.Determine'),
          showCancelButton:false,
          type: 'warning',
          center: true
          })
          return
          }
          this.option.series[0].data=Data.data.net3gwan1
          this.option.series[1].data=Data.data.net3gwan2
          this.option.series[2].data=Data.data.netlan
          this.option.series[3].data=Data.data.netwan
          this.option.xAxis.data=Data.Time
        break;
        case 1:
            //使用自定义函数制作设备数据与数据时间
          Data=GetFlowstatisticsYear(res.data.data,data.year)
          console.log('data');
          console.log(Data);
          Object.keys(Data.data).length>0?this.CharShow=true:this.CharShow=false
          this.option.series[0].data=Data.data.net3gwan1
          this.option.series[1].data=Data.data.net3gwan2
          this.option.series[2].data=Data.data.netlan
          this.option.series[3].data=Data.data.netwan
          this.option.xAxis.data=Data.Time
        break;
        default:
          break;
      }
      if(Object.keys(Data.data).length<1){
          this.$confirm(this.$t('lang.ReportManagement.datatype'), this.$t('lang.ReportManagement.setPrompt'), {
          confirmButtonText: this.$t('lang.ReportManagement.Determine'),
          showCancelButton:false,
          type: 'warning',
          center: true
        })
      }
      })
    }
  },
  computed:{
    ...mapGetters(['defaultGroupId'])
  }
};
</script>

<style scoped>
.inputlist {
  width: 1.8rem;
  margin: 0.1rem;
}
.echarts {
    width: 100%;
    height: 90%;
    }
</style>
